import React, { useEffect } from "react";
import { DismissRegular } from "@fluentui/react-icons";
import { MessageBar, MessageBarBody, MessageBarActions, Button, makeStyles } from "@fluentui/react-components";
import { useMessage } from './MessageContext'; 

const useStyles = makeStyles({
  messageContainer: {
    maxWidth: "320px",
    position: "absolute",
    top: "0",
    right: "0",
    left: "0",
    zIndex: 2,
  },
  messageBar: {
    border: "0",
    borderRadius: "0",
  },
});

const Message = () => {
  const styles = useStyles();
  const { message, messageType, dismissMessage } = useMessage();

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        dismissMessage();
      }, 5000);
  
      return () => clearTimeout(timer);
    }
  
    return () => {};
  }, [message, dismissMessage]);
  
  if (!message) return null;

  return (
    <div className={styles.messageContainer}>
      <MessageBar intent={messageType} className={styles.messageBar}>
        <MessageBarBody>{message}</MessageBarBody>
        <MessageBarActions containerAction={
          <Button onClick={dismissMessage} appearance="transparent" icon={<DismissRegular />} />
        }></MessageBarActions>
      </MessageBar>
    </div>
  );
};

export default Message;
